import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { clientApplication } from './msalProvider';

const TOKEN_SCOPES = ['user.read'];

let inflightRequest = null;

export async function acquireIdToken({ forceRefresh = false } = {}) {
  const account = clientApplication.getActiveAccount() ?? clientApplication.getAllAccounts()[0];

  if (!account) return null;

  const request = {
    scopes: TOKEN_SCOPES,
    account,
    forceRefresh,
  };

  // Deduplicate: if a silent request is already inflight, piggyback on it
  if (inflightRequest && !forceRefresh) {
    return inflightRequest;
  }

  inflightRequest = (async () => {
    try {
      const response = await clientApplication.acquireTokenSilent(request);
      return response.idToken;
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
        // 24h refresh token expired, Conditional Access, or consent required.
        // Redirect is safer than popup (no popup blockers, works in Safari ITP).
        await clientApplication.acquireTokenRedirect({
          scopes: TOKEN_SCOPES,
          account,
          claims: error.claims,
        });
        // Page will reload after redirect — return null in the meantime
        return null;
      }
      throw error;
    } finally {
      inflightRequest = null;
    }
  })();

  return inflightRequest;
}
